import React from 'react';

function GridDetalhamentoFaturamento(){
    return <h1>GridDetalhamentoFaturamento</h1>
}

export default GridDetalhamentoFaturamento;